import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";

// PRODUCCION
const firebaseConfig = {
  apiKey: "AIzaSyCmIoZiIfBCNPW6DxTE0zSbY18hqleZ6Fo",
  authDomain: "extragestor.firebaseapp.com",
  databaseURL: "https://extragestor.firebaseio.com",
  projectId: "extragestor",
  storageBucket: "extragestor.appspot.com",
  messagingSenderId: "288968179838"
};

// DESARROLLO
// const firebaseConfig = {
//   apiKey: "AIzaSyBClcNjIYnQVdRrQWb8P7I0ugUhL8VGjGE",
//   authDomain: "dev-extragestor.firebaseapp.com",
//   databaseURL: "https://dev-extragestor.firebaseio.com",
//   projectId: "dev-extragestor",
//   storageBucket: "dev-extragestor.appspot.com",
//   messagingSenderId: "132277292769"
// };

export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firebaseDB = firebase.database();
export const rootRef = firebaseDB.ref();

export const firebaseAuth = firebaseApp.auth();

export const storage = firebase.storage();
export const storageRef = storage.ref();

export const persistence = firebase.auth.Auth.Persistence;



// WEBPACK FOOTER //
// ./src/config/firebase.js